import { gql } from '@apollo/client';
import { TTBag } from './createTTBag';

export const CREATE_TT_BAGS = gql`
    mutation CreateTTBags($input: CreateTTBagsInput!) {
        result: createTTBags(input: $input) {
            bags {
                id
                bagNumber
                bagType
                businessType
                warehouseId
                sortingCode
                fromLocation
                toLocation
                nextStop
                carrierCode
                status
                createdAt
                ttBizType
                sortingRuleFirst
                sortingRuleSecond
            }
            successCount
            errorMessage
        }
    }
`;

/** 单个尾程商的预分拣多选（ALL 已在前端展开为具体码） */
export interface TTBagPresortSelectionInput {
    carrierCode: number;
    presortCodes: string[];
    includeNoPresort: boolean;
}

/** 单个尾程商的服务多选（分拣规则第三段）；无服务的尾程商不传，后端退回枚举缩写 */
export interface TTBagServiceSelectionInput {
    carrierCode: number;
    serviceCodes: string[];
    includeUndifferentiated: boolean;
}

/** 批量建包/组合预览共用入参（各维度 ALL 已展开） */
export interface CreateTTBagsInput {
    warehouseId: string;
    /** FBT / CBT / UNLIMITED */
    ttBizTypes: string[];
    nextStops: string[];
    carrierCodes: number[];
    presortSelections: TTBagPresortSelectionInput[];
    /** 各尾程商的服务多选（分拣规则第三段）；无服务的尾程商不含在内 */
    serviceSelections?: TTBagServiceSelectionInput[];
    to?: string;
    bagQuantityPerRule: number;
    /** SWX 本地派送尾程四段码（LA-PHX-N-01）；选到具体格口才传，ALL/未勾选不传 */
    lmSortingCode?: string;
}

export interface CreateTTBagsResponse {
    result: {
        bags: (TTBag & {
            ttBizType?: string;
            sortingRuleFirst?: string;
            sortingRuleSecond?: string;
        })[];
        successCount: number;
        errorMessage?: string;
    };
}
